/* oxlint-disable formatjs/no-literal-string-in-jsx -- Please check and fix */
import type { ReactElement } from 'react';
import { ProgressBar as AriaProgressBar, type ProgressBarProps } from 'react-aria-components';
import cx from 'clsx';
import styles from './progress-bar.module.css';

interface ProgressBarComponentProps extends ProgressBarProps {
  type?: 'primary' | 'secondary' | 'success' | 'warning' | 'tertiary';
  size?: 'xsmall' | 'small' | 'medium';
  wrapperClassName?: string;
}

export function ProgressBar({
  type = 'primary',
  size = 'small',
  className,
  wrapperClassName,
  ...props
}: ProgressBarComponentProps): ReactElement {
  return (
    <AriaProgressBar
      aria-label="progress bar"
      className={cx(styles.reactAriaProgressBar, className)}
      data-test-progress-bar
      {...props}
    >
      {({ percentage }) => (
        <div
          className={cx(
            styles.wrapper,
            size === 'xsmall' && styles.wrapperXSmall,
            size === 'medium' && styles.wrapperMedium,
            wrapperClassName
          )}
        >
          <div
            className={cx(
              styles.progressBar,
              size === 'xsmall' && styles.xsmall,
              size === 'medium' && styles.medium,
              type === 'secondary' && styles.purple,
              type === 'success' && styles.success,
              type === 'warning' && styles.warning,
              type === 'tertiary' && styles.tertiary
            )}
            data-percentage-progress-bar
            data-test-progress-bar-inner
            style={{
              width: `${percentage}%`,
            }}
          />
        </div>
      )}
    </AriaProgressBar>
  );
}
